module.exports = __webpack_public_path__ + "files/7c3604e3599d0bef03d7a108c10c87d2.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/symbols-1.png
// module id = 1476
// module chunks = 60